import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { APP_CONFIG, APP_DI_CONFIG } from './constant/app-constant';
import { HttpClientService } from './service/http/http-client.service';
import { CookiesService } from './service/cookies/cookies.service';
import { LoaderComponent } from './component/loader/loader.component';
import {  LoaderComponentMasterData, LoaderComponentUserData, LoaderComponentAppointmentData } from './component/loader-data/loader.component';
@NgModule({
  imports: [
    CommonModule
  ],
  exports : [LoaderComponent],
  declarations: [LoaderComponent],
  providers:[
     HttpClientService,
     CookiesService,  LoaderComponentMasterData, LoaderComponentUserData,
     {provide: APP_CONFIG, useValue: APP_DI_CONFIG}
  ] 
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts